import { Component, Input, OnInit } from "@angular/core";
import { IWebsiteHomePage } from "src/app/models/i-website";

@Component({
    selector: "app-app-download",
    templateUrl: "./app-download.component.html",
    styleUrls: ["./app-download.component.scss"],
})
export class AppDownloadComponent implements OnInit {
    @Input("data") data: IWebsiteHomePage | null = null;
    constructor() {}

    ngOnInit(): void {}
}
